export const css = {
	icon: '_3DZxDnlB',
	clockIcon: 'Vul___jq',
	eyeIcon: 'Qv5JWuZP',
	eyeSlashIcon: '_2cQL0F_P',
	plusIcon: '_3i1n4mTm',
	minusIcon: '_1koQxngT',
	checkIcon: 'rhRxNngc',
	closeIcon: '_3hoUJVMC',
	leftIcon: 'L3apqY-j',
	rightIcon: '_2HKFw8e5',
	upIcon: 'cI7LrYPC',
	downIcon: '_27hdsdCq',
	upAltIcon: 'KCTZGh_f',
	downAltIcon: '_3hQXm7bl',
	searchIcon: 'Zfmoa67P',
	barsIcon: '_3EsCmIJ8',
	settingsIcon: '_2Eu4Xrbb',
	alertIcon: '_3R-SLEaM',
	helpIcon: '_3XA3Kcum',
	infoIcon: 'DmUL9rsN',
	cancelIcon: 'PN88X4H8',
	checkedBoxIcon: 'wiJRE6Nv',
	phoneIcon: '_2LV5_JfP',
	editIcon: '_2Wvhde0l',
	dateIcon: '_1uVqzGyq',
	linkIcon: '_3aJLumZ-',
	locationIcon: '_1Uq6GkoE',
	secureIcon: '_19aHYbl7',
	mailIcon: '_1UYZVhg-',
	starIcon: '_1vU9gSe8',
	' _key': 'afcpe-theme/afcpe/dojo/icon'
};

export default css;
